import Vue from 'vue'
// import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import App from './App.vue'
// import 'amfe-flexible' //移动端适配的JavaScript库
import router from '../src/router/index'
// import ElementUI from 'element-ui'
// import elementUIVerify from 'element-ui-verify'
// import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
// import '@/styles/index.scss' // global css
// import 'element-ui/lib/theme-chalk/index.css'

// import Vconsole from 'vconsole'

// let vConsole = new Vconsole()

// set ElementUI lang to EN
// Vue.use(ElementUI, { locale })
// Vue.use(elementUIVerify)

// Vue.use(vConsole)
Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next();
});

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')

// new Vue({
//     el: '#app',
//     router,
//     // store,
//     render: h => h(App)
// })
